import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pas2',
  templateUrl: './pas2.component.html',
  styleUrls: ['./pas2.component.scss']
})
export class Pas2Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
